<template>
  <SysDialog
    v-model="dialog_ativo"
    titulo="Nova Lista de Separação"
    :largura="800"
  >
    <template #ativador>
      <slot name="ativador" :callback="abrirDialog">
        <v-btn small color="primary" @click="abrirDialog">
          <v-icon>mdi-plus</v-icon>
          Novo
        </v-btn>
      </slot>
    </template>

    <div v-if="dialog_ativo" class="pb-3">
      <div class="d-flex align-center">
        <div class="w-50-porcento pr-2">
          <v-text-field
            v-model="cadastro_lista.nome"
            label="Nome da Lista*"
            outlined
            hide-details
          />
        </div>

        <div class="w-50-porcento pl-1">
          <SysFilialGrupoAutocomplete
            v-model="cadastro_lista.filtros.filiais_destino"
            label="Filiais de destino*"
            outlined
            hide-details
            multiple
          />
        </div>
      </div>

      <div class="d-flex align-center mt-5">
        <div class="w-50-porcento pr-2">
          <SysSegmentoAutocomplete
            v-model="cadastro_lista.filtros.segmentos"
            label="Segmentos"
            outlined
            hide-details
            multiple
          />
        </div>

        <div class="w-50-porcento pl-1">
          <SysSecaoAutocomplete
            v-model="cadastro_lista.filtros.secoes"
            label="Seções"
            outlined
            hide-details
            multiple
            :ids-segmento="cadastro_lista.filtros.segmentos"
          />
        </div>
      </div>

      <div class="d-flex align-center mt-5">
        <div class="w-50-porcento pr-2">
          <SysCategoriaAutocomplete
            v-model="cadastro_lista.filtros.categorias"
            label="Categorias"
            outlined
            hide-details
            multiple
            :ids-segmento="cadastro_lista.filtros.segmentos"
            :ids-secao="cadastro_lista.filtros.secoes"
          />
        </div>

        <div class="w-50-porcento pl-1">
          <SysFornecedorAutocomplete
            v-model="cadastro_lista.filtros.fornecedores"
            label="Fornecedores"
            outlined
            hide-details
            multiple
            :ids-segmento="cadastro_lista.filtros.segmentos"
            :ids-secao="cadastro_lista.filtros.secoes"
          />
        </div>
      </div>

      <div class="d-flex align-center mt-5">
        <div class="w-50-porcento pr-2">
          <SysProdutosAutocomplete
            v-model="cadastro_lista.filtros.produtos"
            :filiais="cadastro_lista.filtros.filiais_destino"
            :segmentos="cadastro_lista.filtros.segmentos"
            :secoes="cadastro_lista.filtros.secoes"
            :fornecedores="cadastro_lista.filtros.fornecedores"
            desabilitar_botao_selecao_todos
          />
        </div>

        <div class="w-50-porcento pl-1">
          <StatusProdutoAutocomplete
            v-model="cadastro_lista.filtros.status_produto"
            label="Status Produtos"
            outlined
            hide-details
          />
        </div>
      </div>
    </div>

    <template #actions>
      <v-btn text color="primary" :disabled="!DADOS_VALIDOS_COMPUTED" @click="salvar">
        salvar
      </v-btn>
    </template>
  </SysDialog>
</template>

<script setup>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import {computed, ref} from "vue";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete.vue";
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete.vue";
import SysCategoriaAutocomplete from "@/components/utils/crud/SysCategoriaAutocomplete.vue";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete.vue";
import SysProdutosAutocomplete from "@/components/utils/crud/SysProdutosAutocomplete.vue";
import SysSecaoAutocomplete from "@/components/utils/crud/SysSecaoAutocomplete.vue";
import api from "@/api/api";
import {logout} from "@/helpers";
import StatusProdutoAutocomplete from "@/components/drp/ListaSeparacao/Crud/StatusProdutoAutocomplete.vue";

const props = defineProps({
  lista_separacao: Object,
});

const emit = defineEmits(['update:lista-separacao'])

const dialog_ativo = ref(false);

const cadastro_lista = ref({
  nome: '',
  filtros: {
    filiais_destino: [],
    segmentos: [],
    secoes: [],
    categorias: [],
    fornecedores: [],
    produtos: [],
    status_produto: [],
  },
});

function abrirDialog() {
  dialog_ativo.value = true;

  if (props.lista_separacao) {
    const clone = JSON.parse(JSON.stringify(props.lista_separacao));
    cadastro_lista.value.nome = clone.nome;
    cadastro_lista.value.filtros = {...cadastro_lista.value.filtros, ...clone.filtros};
  }
}

const DADOS_VALIDOS_COMPUTED = computed(() => {
  const {nome, filtros: { filiais_destino }} = cadastro_lista.value;
  return nome && nome.length > 0 && filiais_destino && filiais_destino.length;
});

function salvar() {
  if (!DADOS_VALIDOS_COMPUTED.value) return;

  const parametros = {
    ...cadastro_lista.value,
    id: props.lista_separacao ? props.lista_separacao.id : null,
  };

  api.post('drp/listas-separacao', parametros)
    .then(() => {
      resetarDados();
      emit('update:lista-separacao', {});
    })
    .catch(logout);
}

function resetarDados() {
  dialog_ativo.value = false;
  cadastro_lista.value = {
    nome: '',
    filtros: {
      filiais_destino: [],
      segmentos: [],
      secoes: [],
      categorias: [],
      fornecedores: [],
      produtos: [],
    },
  };
}
</script>
